module.exports = __webpack_public_path__ + "images/rangerover_small0d6202b5ea9750af573f8bedea2ab98e.png";